import { useEffect, useState } from 'react'
import { createMgmTask } from '../../crud/integration.crud'

const getStateFromProperties = (properties) => {
  if (!Array.isArray(properties)) {
    throw new Error('properties argument must be an array.')
  }

  const props = {}
  // eslint-disable-next-line no-restricted-syntax
  for (const property of properties) {
    const isArrayProperty = Array.isArray(property?.defaultValue) && property?.defaultValue?.length

    props[property.name] = isArrayProperty ? getStateFromProperties(property.defaultValue) : property.defaultValue
  }

  return props
}

const stateOptions = {
  triggerTask: false,
}

/**
 * useTaskManagement Hook
 * @param {task} task definition that constains task name and properties (name, default value), for instance
 * {
 *  name: "taskName"
 *  properties: [
 *    name: "propertyName",
 *    defaultValue: "none"
 *  ]
 * }
 * @returns object { state, setState, triggerTask }
 */
const useTaskManagement = (task) => {
  const [innerState, setInnerState] = useState(getStateFromProperties(task?.properties ?? []))
  const [innerTask] = useState(task ?? {})
  const [isTaskTriggered, setIsTaskTriggerTask] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions, no-use-before-define
    isTaskTriggered && triggerTask()
  }, [innerState]) // eslint-disable-line react-hooks/exhaustive-deps

  const getTaskPayload = () => ({
    customerId: innerTask.customer.id,
    integrationType: innerTask.integrationType,
    mgmTaskId: innerTask.mgmTaskId,
    userId: innerTask.user.id,
    parameters: {
      taskName: innerTask.taskName,
      actions: innerState,
    },
  })

  const setState = (state, options) => {
    const { triggerTask } = { ...stateOptions, ...options }

    setInnerState({ ...innerState, ...state })
    setIsTaskTriggerTask(triggerTask)
  }

  const triggerTask = async (callback, payload) => {
    const innerPayload = payload ?? getTaskPayload()

    const response = await createMgmTask(innerPayload)

    if (callback) {
      callback(innerPayload, response)
    }
  }

  if (!task) {
    return null
  }

  return { state: innerState, setState, triggerTask, getTaskPayload }
}

export { useTaskManagement }
